
const messages = {
    en: {
       delivery: {
          productCategory: {
            name: 'ProductCategory',
            title: 'ProductCategory management',
            subtitle: 'View, search, create, edit and delete ProductCategory',
            creating: 'Creating ProductCategory',
            editing: 'Editing ProductCategory',
            deleting: 'Deleting ProductCategory',
            showing: 'Showing ProductCategory',
            menu: 'ProductCategory',
            labels: {
                name: 'Name',
                backgroundColor: 'Background Color',
                borderColor: 'Border Color',
                fontColor: 'Font color',
                iconColor: 'Icon color',
                icon: "Icon",
                surcharge: 'Surcharge',
                minimumDeliveryQuantity: 'Minimum delivery quantity',
                minimumTakeAwayQuantity: 'Minimum take away quantity'
            },

          }
       }
    },
    es: {
       delivery: {
          productCategory: {
            name: 'ProductCategory',
            title: 'Administración de ProductCategory',
            subtitle: 'Ver, buscar, crear, editar, y borrar ProductCategory',
            creating: 'Creando ProductCategory',
            editing: 'Modificando ProductCategory',
            deleting: 'Eliminando ProductCategory',
            showing: 'Detalles de ProductCategory',
            menu: 'ProductCategory',
            labels: {
                name: 'Nombre',
                backgroundColor: 'Color de fondo',
                borderColor: 'Color de borde',
                fontColor: 'Color de fuentes',
                iconColor: 'Color de icono',
                icon: "Icono",
                surcharge: 'Recargo',
                minimumDeliveryQuantity: 'Minima cantidad Delivery',
                minimumTakeAwayQuantity: 'Minima cantidad Take away'
            },

          }
       }
    },
    pt: {
       delivery: {
          productCategory: {
            name: 'ProductCategory',
            title: 'Administração de ProductCategory',
            subtitle: 'Ver, buscar, criar, editar e usar ProductCategory',
            creating: 'Criando ProductCategory',
            editing: 'Edição ProductCategory',
            deleting: 'Apagando ProductCategory',
            showing: 'Detalhes do ProductCategory',
            menu: 'ProductCategory',
            labels: {
                name: 'Nome',
                backgroundColor: 'Color de fondo',
                borderColor: 'Color de borde',
                fontColor: 'Color de fuentes',
                iconColor: 'Icon color',
                icon: "Icon",
                surcharge: 'Recargo',
                minimumDeliveryQuantity: 'Minima cantidad Delivery',
                minimumTakeAwayQuantity: 'Minima cantidad Take away'
            },

          }
       }
    }
}

export default messages
